import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
// Self-hosted so type is the same everywhere: without it Macs got SF, Windows Segoe UI, and Linux (the visual
// baselines) a fallback with no semibold. Vite bundles the woff2 files; a browser downloads only the subsets a page
// uses (unicode-range), in practice latin.
import '@fontsource-variable/inter/wght.css';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
